export default {
  async checkout() {
    await new Promise((r) => setTimeout(r, 15000)); // simulate waiting for network
  },
};
